import React from 'react';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';

var SMSkeleton = function SMSkeleton(_ref) {
  var width = _ref.width,
      height = _ref.height,
      color = _ref.color,
      highlightColor = _ref.highlightColor,
      count = _ref.count,
      duration = _ref.duration;
  return /*#__PURE__*/React.createElement(SkeletonTheme, {
    color: color,
    highlightColor: highlightColor
  }, /*#__PURE__*/React.createElement(Skeleton, {
    height: height,
    width: width,
    duration: duration,
    count: count
  }));
};

SMSkeleton.defaultProps = {
  width: null,
  height: 60,
  color: '#616161',
  highlightColor: 'rgb(146, 255, 195)',
  count: 1,
  duration: 6
};
export { SMSkeleton };